import { combineReducers } from 'redux';
import AlertBox from './components/AlertBox/alertbox.reducers';
import Common from './components/CommonServices/commonservices.reducers';

export default combineReducers({
  Common,
  AlertBox
});
